import styled from "@emotion/styled"
import CaseStudiesList from "./CaseStudiesList"

const CaseStudiesGrid = styled(CaseStudiesList)`
  display: grid;
  grid-gap: 25px;
  grid-auto-flow: row;

  ${({ theme }) => theme.breakpoints.down("xl")} {
    grid-template-columns: 1fr;
  }

  &[data-grid-pattern] {
    ${({ theme }) => theme.breakpoints.up("xl")} {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-auto-rows: minmax(380px, auto);
      width: 100%;

      & > div {
        min-height: 380px;
        grid-column: var(--grid-column, 1 / -1);
        grid-row: var(--grid-row, auto);
        display: flex;
        margin-bottom: 0;
      }

      & > div {
        transition: transform 0.3s ease;
        width: 100%;
        position: relative;
        justify-self: stretch;
        align-self: stretch;

        & > * {
          width: 100%;
          max-width: 100%;
          flex: 1;
        }

        will-change: transform;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;

        &:hover {
          transform: translate3d(0, -5px, 0);
        }
      }

      & > div + div {
        margin-top: 0;
      }
    }
  }
`

export default CaseStudiesGrid
